import type {Three as THREE} from "#material/three/exports"
import {ThreeTsl as TSL} from "#material/three/exports"

export const threeBlendNormals = TSL.Fn(([color1, color2]: [color1: THREE.Node<"color">, color2: THREE.Node<"color">]) => {
    const t = color1.rgb.mul(TSL.vec3(2.0, 2.0, 2.0)).add(TSL.vec3(-1.0, -1.0, 0.0))
    const u = color2.rgb.mul(TSL.vec3(-2.0, -2.0, 2.0)).add(TSL.vec3(1.0, 1.0, -1.0))

    return TSL.color(t.mul(TSL.dot(t, u)).sub(u.mul(t.z)).add(1.0).mul(0.5))
})
